export const codeSnippet = {
	code1: `function callbackExample(name, callback) {
  console.log('Hello \$\{name}');
  callback();
}

callbackExample("John", function() {
  console.log("Callback function has been invoked.");
});

Output
Hello John
Callback function has been invoked.`,
  code2: `function getData(url, callback) {
  fetch(url)
    .then(response => response.json())
    .then(data => callback(data))
    .catch(error => console.log(error))
}

getData("https://api.example.com/data", function(data) {
  console.log(data);
});`,
  code3: `const delayedMessage = new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve("Hello, this message was delayed.");
  }, 3000);
});

delayedMessage.then(message => console.log(message));`,
  code4: `const fetchData = url => {
  return new Promise((resolve, reject) => {
    fetch(url)
      .then(response => response.json())
      .then(data => resolve(data))
      .catch(error => reject(error));
  });
};

fetchData("https://api.example.com/data")
  .then(data => console.log(data))
  .catch(error => console.log(error));`,
  code5: `async function getData(url) {
  try {
    const response = await axios.get(url);
    console.log(response.data);
  } catch (error) {
    console.log(error);
  }
}

getData("https://api.example.com/data");`,
  code6: `function outerFunction(x) {
  return function innerFunction(y) {
    return x + y;
  }
}

const add = outerFunction(5);
console.log(add(3)); // 8
console.log(add(4)); // 9`,
  code7: `function outerFunction(x) {
    function innterFunction(y) {
        return x+y;
    }
    return innterFunction;
}
const outer = outerFunction(2);
console.log(outer(3)); // 5
// Even though outerFunction has finished executing, the inner function still remembers 'x = 2'

const BankAccount = (bal)=> {
    let balance = bal; // Private variable
    let accountNumber = Math.random().toString(36).substr(2, 9);
    
    return {
        deposit: function(amount) {
            if (amount > 0) {
                balance += amount;
                console.log('Deposited $amount. New balance: $balance');
            }
        },
        
        withdraw: function(amount) {
            if (amount > 0 && amount <= balance) {
                balance -= amount;
                console.log('Withdrew $amount. New balance: $balance');
            } else {
                console.log('Insufficient funds');
            }
        },
        
        getBalance: function() {
            return balance;
        },
        
        getAccountNumber: function() {
            return accountNumber;
        }
    };
};
const account = BankAccount(10);

account.deposit(100);    // Deposited $100. New balance: $100
account.withdraw(30);    // Withdrew $30. New balance: $70
console.log(account.getBalance()); // 70

// balance and accountNumber are not directly accessible
console.log(account.balance); // undefined`,
  code8: `let obj = {name: 'John'};
function sayName() {
    console.log(this.name);
}

sayName.call(obj); // prints 'John'`,
  code9: `let obj = {name: 'John'};
function sayName(age) {
    console.log(this.name + ' is ' + age + ' years old.');
}
let args = ['25'];
sayName.apply(obj, args); // prints 'John is 25 years old.'`,
  code10: `console.log(x); // undefined
var x = 5;`,
  code11: `var x;
console.log(x); // undefined
x = 5;`,
  code12: `sayHello(); // "Hello, World!"
function sayHello() {
    console.log("Hello, World!");
}`,
  code13: `sayHello(); // TypeError: sayHello is not a function
let sayHello = function() {
    console.log("Hello, World!");
}`

}